import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import SectionTitle2 from "../SectionTitle2/SectionTitle2";

const settings = {
  dots: false,
  arrows: true,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const ClickHandler = () => {
  window.scrollTo({
    top: 0,
    left: 10,
    behavior: "smooth",
  });
};

const ProjectSection2 = (props) => {
  const [maxHeight, setMaxHeight] = useState(0);
  const itemRefs = useRef([]);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;
  const projects = props.projects;

  useEffect(() => {
    if (projects.length > 0) {
      const handleResize = () => {
        const heights = itemRefs.current.map((el) => el?.offsetHeight || 0);
        setMaxHeight(Math.max(...heights));
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [projects]);

  const handleImageLoad = () => {
    const heights = itemRefs.current.map((el) => el?.offsetHeight || 0);
    setMaxHeight(Math.max(...heights));
  };

  if (!projects) return null;

  return (
    <section
      className={`wpo-project-section-s2 section-padding ${props.pClass}`}
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.3)", // 🔥 new slight black background
        color: "#fff", // ensures text stays readable
        paddingTop: "40px", // reduce vertical padding
        paddingBottom: "40px",
      }}
    >
      <div className="container">
        <SectionTitle2
          subTitle={"OUR PROJECTS"}
          Title={"Successfull Work of StarFamily"}
        />
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col col-xs-12 sortable-project">
            <div className="wpo-project-container project-slider owl-carousel">
              <Slider {...settings}>
                {projects.map((project, prj) => (
                  <div className="grid" key={prj}>
                    <div
                      className="wpo-project-item"
                      ref={(el) => (itemRefs.current[prj] = el)}
                      style={{
                        minHeight: maxHeight || "auto",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={`${apiUrl}/storage/` + project.banner}
                        alt="project"
                        className="img img-responsive"
                        onLoad={handleImageLoad}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          flex: "1 0 auto",
                        }}
                      />
                      <div className="wpo-project-text">
                        <h3>
                          <Link
                            onClick={ClickHandler}
                            to={`/project-single/${project.id}`}
                          >
                            {project.title}
                          </Link>
                        </h3>
                        <Link
                          onClick={ClickHandler}
                          className="arrow-btn"
                          to={`/project-single/${project.id}`}
                        >
                          <i className="fi flaticon-right-arrow-1"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection2;
